/**
 * 应用入口文件
 *
 * 初始化 Vue 3 应用，按顺序挂载:
 * 1. Vue Router - 路由管理
 * 2. Ant Design Vue - UI 组件库
 * 3. 挂载到 #app 根节点
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

// 全局捕获并抑制 ResizeObserver 的良性循环警告
// Ant Design 组件在尺寸变化时会触发此警告，不影响功能
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop')) {
    event.stopPropagation()
    event.stopImmediatePropagation()
    event.preventDefault()
    return true
  }
})

const app = createApp(App)
app.use(router)   // 注册路由
app.use(Antd)     // 注册 Ant Design Vue
app.mount('#app') // 挂载到 DOM

